var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-block products-img"},[_c('div',{staticClass:"wide"},[_c('div',{staticClass:"mid"},[_c('div',{staticClass:"grayscale"},[_c('div')]),_c('div',{staticClass:"big_image"})])])])
}]

export { render, staticRenderFns }